import React from "react";
import {
  GSActionBar,
  GSEmptyList,
  GSForm,
  GSItemList,
  GSSidePanelPage,
} from "golfstatus_react_components";
import { faChevronLeft, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";

//import scss
import "./tournament-reporting-payout-request.scss";
import { useFormDataValidation } from "../../../hooks/formHooks";
import {
  useNotificationBanner,
  useNotificationNavigation,
} from "../../../hooks/notificationHooks";
import { getPayoutRequestForm } from "../../../forms/ReportingForm";
import TournamentReportingOrderSummary from "./tournament-reporting-order-summary";
import { useSelector } from "react-redux";
import {
  clearNotifications,
  getTournamentHasOpenInvoices,
  requestTournamentPayout,
  resendProductInvoices,
  selectCurrentPayout,
  selectHasOpenInvoices,
  selectNotifications,
  selectOrderSummary,
  updatePayout,
} from "../../../reducers/reportingSlice";
import { useDispatch } from "react-redux";
import { selectCurrentTournament } from "../../../reducers/tournamentSlice";
import { useEffect } from "react";
import { selectOrganizationBankAccount } from "../../../reducers/organizationSlice";

//Name the component
const TournamentReportingPayoutRequest = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const orderSummary = useSelector(selectOrderSummary);
  const currentPayout = useSelector(selectCurrentPayout);
  const notifications = useSelector(selectNotifications);
  const tournament = useSelector(selectCurrentTournament);
  const orgBankAccount = useSelector(selectOrganizationBankAccount);
  const hasOpenInvoices = useSelector(selectHasOpenInvoices);

  const match = useMatch("/:tournamentID/*");

  useEffect(() => {
    return () => {
      dispatch(updatePayout({}));
    };
  }, [dispatch]);

  useEffect(() => {
    if (match?.params?.tournamentID) {
      dispatch(getTournamentHasOpenInvoices(match?.params?.tournamentID));
    }
  }, [dispatch, match?.params?.tournamentID]);

  useNotificationNavigation(
    "saved",
    notifications,
    -1,
    "Request Tournament Payout"
  );

  const [context, isValid, setIsValid] = useFormDataValidation({
    initialValid: false,
    data: currentPayout,
    setData: updatePayout,
  });

  const save = () => {
    setIsValid(false);

    let typ = null;
    if (orgBankAccount?.status === 'verified') {
      typ = "ach";
    } else if (tournament?.organization?.stripeId) {
      typ = "stripe_transfer";
    } else {
      return;
    }

    let payout = { ...currentPayout };
    payout.payoutType = typ;
    payout.tournament = tournament;
    dispatch(requestTournamentPayout(payout));
  };

  const getDrawerActions = () => {
    if (hasOpenInvoices) {
      return [];
    }
    let actions = [
      {
        name: "Request Payout",
        isDisabled: !isValid,
        action: save,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: hasOpenInvoices ? "Payout Unavailable" : `Payout Details`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getUnavailableEmptyMessage = () => {
    return (
      <GSEmptyList
        title="Invoice Payment Needed"
        detail="This tournament has been invoiced for GolfStatus products, and those invoices must be paid before funds can be released. Invoices for participants are unaffected and will not be resent. For help with payment, please contact our support team."
        actions={[
          {
            title: "Resend Product Invoices",
            buttonIcon: faPaperPlane,
            onClick: () => {
              dispatch(resendProductInvoices(match?.params?.tournamentID))
            },
            type: "black no-wrap",
          },
        ]}
      />
    );
  };

  const getUnavailableContent = () => {
    return (
      <gs-form>
        <GSActionBar type="form-header" header="Request Payout Unavailable" />
        <GSItemList
          emptyMessage={getUnavailableEmptyMessage()}
          type="vertical"
        />
      </gs-form>
    );
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={
          <TournamentReportingOrderSummary
            hideNetRevenue
            hideRefunds
            hidePayouts
            {...orderSummary}
          />
        }
        formSections={getPayoutRequestForm(context)}
      ></GSForm>
    );
  };

  const timeoutAction = () => {
    dispatch(clearNotifications())
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <tournament-reporting-payout-request>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={hasOpenInvoices ? getUnavailableContent() : getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </tournament-reporting-payout-request>
  );
};

//export the new namet
export default TournamentReportingPayoutRequest;
